// @TODO: ŠFD trofeJa :)
import { toRem, toRems } from "../../../../../helpers/theme";

/* eslint-disable quote-props, no-dupe-keys, max-len */
const style = ({ theme }) => {
    const translateBlock = (position, value) => ({
        position: "absolute",
        [position]: 0,
        left: 0,
        right: 0,
        transform: `translateY(${value})`,
        textAlign: "center",
    });

    return {
        maxWidth: toRem(465),
        width: "100%",
        marginTop: toRem(30),
        marginBottom: toRem(30),
        "& .trophyCard": {
            position: "relative",
            border: `1px solid ${theme.colors.userProfileHead.trophy.card.border}`,
            paddingTop: toRem(15),
            paddingBottom: toRem(40),
            borderRadius: toRem(8),
        },
        "& .trophyCard_list": {
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
        },
        "& .trophyCard_head": {
            ...translateBlock("top", `calc(-50% - 5px)`),
        },
        "& .trophyCard_title": {
            padding: toRems([0, 8]),
            fontSize: toRem(18),
            lineHeight: 1.2,
            fontWeight: theme.typography.fontWeight.bold,
            backgroundColor: theme.colors.userProfileHead.trophy.title.background,
        },
        "& .trophyItem": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: toRems([0, 15]),
            textAlign: "center",
        },
        "& .trophyItem_image": {
            minWidth: toRem(65),
            width: "100%",
            [theme.breakpoints.up("md")]: {
                maxWidth: toRem(80),
            },
        },
        "& .trophyItem_title": {
            fontSize: toRem(12),
            lineHeight: 1.2,
            fontWeight: theme.typography.fontWeight.bold,
            [theme.breakpoints.up("md")]: {
                fontSize: toRem(14),
            },
        },
        "& .trophyCard_footer": {
            ...translateBlock("bottom", `calc(50% - 5px)`),
        },
    };
};

export default style;
